import React, {Component} from 'react';
import {Form, Row, Col, Select, Input, Button, message, Switch} from 'antd'
import {listFormItemLayout, tailFormItemLayout} from '../../utills/common'
import {reqCreateAddress, reqUpdateAddress, reqAddressInfo, reqArea} from '../../api'
import authorizeBase from "../../components/authorize/authorizeBase";
import authorizePage from "../../components/authorize/authorizePage";
const AuthButton = authorizeBase(Button)

const {Option} = Select;
let id;
class AddrAdd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            origin: [],
            destination: [],
        };
    }

    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.saveAddress(values);
            }
        });
    };

    saveAddress = async (values) => {
        let result;
        values.defalutFlag ? values.defalutFlag = 'Y' : values.defalutFlag = 'N';
        //提货人关联起运地
        if (values.type === '3') {
            values.relCityId = values.originCityId;
        }
        //通知方 收货人关联目的地
        if (values.type === '2' || values.type === '6') {
            values.relCityId = values.destinationCityId;
        }
        if (id) {
            values.id = id;
            result = await reqUpdateAddress(values);
            if (result.code === 200) {
                this.props.history.replace('/addrList')
            } else {
                message.error(result.message);
            }
        } else {
            result = await reqCreateAddress(values);
            if (result.code === 201) {
                this.props.history.replace('/addrList')
            } else {
                message.error(result.message);
            }
        }

    };
    getAddress = async (id) => {
        let result = await reqAddressInfo(id);
        if (result.code === 200) {
            this.setState(result.data);
        }
    };
    setInitAreaData = async (cityId, type) => {
        let result = await reqArea(type);
        if (result.code === 200) {
            if (type === 'F') {
                this.setState({
                    origin: result.data
                });
            } else if (type === 'T') {
                this.setState({
                    destination: result.data
                })
            }
        } else {
            message.error(result.message);
        }
    };

    componentDidMount() {
        id = this.props.location.state ? this.props.location.state.id : '';
        if (id) {
            this.getAddress(id);
        }
        this.setInitAreaData('', 'F');
        this.setInitAreaData('', 'T');
    }

    render() {
        const {getFieldDecorator} = this.props.form;
        const options1 = this.state.origin.map(d => <Option key={d.cityId}
                                                            value={d.cityId}>{d.countryName + ' ' + d.cityName}</Option>);
        const options2 = this.state.destination.map(d => <Option
            key={d.cityId} value={d.cityId}>{d.countryName + ' ' + d.cityName}</Option>);
        return (
            <div className='order-ticket box-shadow'>
                <div className="head-title">
                    地址管理
                </div>
                <div className="order-ticket-content">
                    <Form {...listFormItemLayout} onSubmit={this.handleSubmit}>
                        <Row>
                            <Col span={12}>
                                <Form.Item label="公司名称">
                                    {getFieldDecorator('company', {
                                        initialValue: this.state.company,
                                        rules: [{required: true, message: '该项必填'},],
                                    })(<Input />)}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="地址">
                                    {getFieldDecorator('address', {
                                        initialValue: this.state.address,
                                        rules: [{required: true, message: '该项必填'},],
                                    })(<Input />)}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="类型">
                                    {getFieldDecorator('type', {
                                        initialValue: this.state.type ? this.state.type : '1',
                                        rules: [{required: true, message: '该项必填'},],
                                    })(<Select onChange={(value) => {
                                        this.setState({type: value, change: true});
                                    }}>
                                        <Option value='1'>发货企业</Option>
                                        <Option value='6'>境外收货方</Option>
                                        <Option value='2'>通知方</Option>
                                        <Option value='3'>仓库联系人</Option>
                                    </Select>)}
                                </Form.Item>
                            </Col>
                            {this.state.type && this.state.type !== '1' ? '' :
                                <Col span={12}>
                                    <Form.Item label="是否默认">
                                        {getFieldDecorator('defalutFlag', {
                                            valuePropName: 'checked',
                                            initialValue: this.state.defalutFlag == 'Y',
                                        })(<Switch/>)}
                                    </Form.Item>
                                </Col>
                            }
                            {this.state.type !== '3' ? '' :
                                <Col span={12}>
                                    <Form.Item label="关联起运地">
                                        {getFieldDecorator('originCityId', {
                                            initialValue: this.state.change || this.state.type !== '3' ? '' : this.state.relCityId,
                                        })(<Select>
                                            {options1}
                                        </Select>)}
                                    </Form.Item>
                                </Col>
                            }
                            {this.state.type !== '2' && this.state.type !== '6' ? '' :
                                <Col span={12}>
                                    <Form.Item label="关联目的地">
                                        {getFieldDecorator('destinationCityId', {
                                            initialValue: this.state.change || ( this.state.type !== '2' && this.state.type !== '6') ? '' : this.state.relCityId,
                                        })(<Select>
                                            {options2}
                                        </Select>)}
                                    </Form.Item>
                                </Col>
                            }
                            <Col span={12}>
                                <Form.Item label="联系人">
                                    {getFieldDecorator('contact', {
                                        initialValue: this.state.contact,
                                    })(<Input />)}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="联系电话">
                                    {getFieldDecorator('phone', {
                                        initialValue: this.state.phone,
                                    })(<Input />)}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="邮箱">
                                    {getFieldDecorator('email', {
                                        initialValue: this.state.email,
                                    })(<Input />)}
                                </Form.Item>
                            </Col>
                        </Row>
                        <div className='box-submit'>
                            <Form.Item {...tailFormItemLayout}>
                                <AuthButton authority="address:update"  type="primary" htmlType="submit">保存</AuthButton>
                            </Form.Item>
                        </div>
                    </Form>
                </div>
            </div>)
    }
}
const AddrAddForm = authorizePage("address:add")(Form.create()(AddrAdd));
export default AddrAddForm;